export const restBase = '/innovator-ai/v1/';
